import { IntegrityMonitorPolicyRuleSetsSectionController } from '../controller/IntegrityMonitorPolicyRuleSetsSectionController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { RuleSetItem } from '../types';

export class IntegrityMonitorPolicyRuleSetsSectionWebComponent extends BaseWebComponentElement {
  public controller: IntegrityMonitorPolicyRuleSetsSectionController | null;
  private selectedRuleSetIdsRef: Array<string>;
  private companyRuleSetsRef: Array<RuleSetItem>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorPolicyRuleSetsSectionController,
    });
  }

  get selectedRuleSetIds(): Array<string> {
    return this.selectedRuleSetIdsRef;
  }

  set selectedRuleSetIds(value: Array<string>) {
    this.selectedRuleSetIdsRef = value;
  }

  get companyRuleSets(): Array<RuleSetItem> {
    return this.companyRuleSetsRef;
  }

  set companyRuleSets(value: Array<RuleSetItem>) {
    this.companyRuleSetsRef = value;
  }

  get disabled(): boolean {
    return this.hasAttribute('disabled');
  }

  set disabled(value: boolean) {
    if (value) {
      this.setAttribute('disabled', '');
    } else {
      this.removeAttribute('disabled');
    }
    this.controller?.view.setDisabled(value);
  }
}
